import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';
import { entries } from 'lodash-es';

import { BetslipType } from '../../../core/betslip-type';
import { IBetslipTypeState } from '../../types/state';
import { IEditMyBetState } from '../state';

@Injectable()
export class EditBetCheckingService {
    constructor(private betslipConfig: BetslipConfig) {}

    hasChanges(state: IBetslipTypeState): boolean {
        if (state.base.currentSelectedType !== BetslipType.EditBet) {
            return false;
        }

        if (state.editBet.addedStake > 0) {
            // User increased the stake
            return true;
        }

        const activePicks = this.getActivePicks(state.editBet);
        const originalPicks = state.editBet.originalPicks;

        return activePicks.length !== originalPicks.length || activePicks.some((p) => originalPicks.every((op) => op !== p));
    }

    isFull(state: IEditMyBetState): boolean {
        const activePicksCount = this.getActivePicks(state).length;
        const addingPicksCount = state.addPicksState.pickList.length;

        return activePicksCount + addingPicksCount >= this.betslipConfig.maxBetslipBets;
    }

    private getActivePicks = (state: IEditMyBetState): string[] =>
        entries(state.picks.pickState)
            .filter((p) => !p[1].isRemoved)
            .map((p) => p[0]);
}
